import { createStore } from "vuex";
import axios from "axios";
import authModule from "./modules/auth";
import router from "../router/router";
import profileModule from "./modules/profile";
import campaignsModule from "./modules/campaigns";
import { calculateDaysDifference } from "../utils";

// import reportsModule from "./modules/reports";

const store = createStore({
    modules: {
        auth: authModule,
        // reports: reportsModule,
        profile: profileModule,
        campaigns: campaignsModule,
    },
    state: {
        country_code: null,
        isLoading: false,
        isModal: false,
        step: 1,
        freeStep: 1,
        imgName: "No design created",
        step_one: {
            companyName: null,
            campaignTitle: null,
            advertisingGoal: null,
        },

        step_two: [],

        step_three: {
            budget: null,
            duration: { end: null, start: null },
        },
        step_four: [],
        points: [],
        impressions: null,
        adLoop: null,
        distance: null,
        step_four_link: {
            link_name: null,
            link_duration: null
        },
        isReviewingPayment: false,
        expectedImpressions: null,
        expectedMinutes: null,
        expectedAdLoops: null,
        assignedCarsState: 1,
        selectedCountriesState: [],
        selectedCitiesState: [],
        selectedDistrictsState: [],
        drivers: [] // Add this line
    },

    mutations: {
        updateImgName(state, payload) {
            state.imgName = payload;
        },
        toggleLoading(state) {
            state.isLoading = !state.isLoading;
        },
        setAssignedCars(state, payload) {
            state.assignedCarsState = payload;
        },
        openReviewPayment(state) {
            state.isReviewingPayment = true
        },
        setSelectedCountries(state, payload) {
            state.selectedCountriesState = payload
        },
        setSelectedCities(state, payload) {
            state.selectedCitiesState = payload
        },
        setSelectedDistricts(state, payload) {
            state.selectedDistrictsState = payload
        },
        closeReviewPayment(state) {
            state.isReviewingPayment = false
        },
        toggleModal(state) {
            state.isModal = true;
            setTimeout(() => {
                state.isModal = false;
                router.push("/campaigns");
                state.step = state.step - 3;
                state.step_one.campaignTitle = null;
                state.step_one.advertisingGoal = null;
                state.step_one.companyName = null;
                state.step_four = [];
                state.step_three.duration.end = null;
                state.step_three.duration.start = null;
                state.step_two = [];
                state.step_three.budget = null;
                state.imgName = "No design created";
            }, 5000);
        },
        restoreStat(state) {
                state.step = 1;
                state.step_one.campaignTitle = null;
                state.step_one.advertisingGoal = null;
                state.step_one.companyName = null;
                state.step_four = null;
                state.step_three.duration.end = null;
                state.step_three.duration.start = null;
                state.step_two = [];
                state.countries = [];
                state.cities = [];
                state.step_three.budget = null;
                state.imgName = "No design created";
                state.assignedCarsState = 1;
                state.selectedCountriesState = [],
                state.selectedCitiesState = [],
                state.selectedDistrictsState = [],
                state.isReviewingPayment = false;
        },
        updataStepO(state, payload) {
            state.step_one.advertisingGoal = payload.advertisingGoal;
            state.step_one.companyName = payload.companyName;
            state.step_one.campaignTitle = payload.campaignTitle;
        },
        updataStepTwo(state, payload) {
            state.step_two = payload;
        },
        updataStepTH(state, payload) {
            state.step_three.budget = payload.budget;
            state.step_three.duration.start = new Date(payload.duration.start);
            state.step_three.duration.end = new Date(payload.duration.end);
        },
        updateExpected(state, payload) {
            state.expectedAdLoops = payload.expectedAdLoops;
            state.expectedImpressions = payload.expectedImpressions;
            state.expectedMinutes = payload.expectedMinutes;
        },
        updastateStepFour(state, payload) { // this is a flag for the media of the Canva File
            state.step_four = []
            state.step_four.push(payload);
        },
        updastateStepFourLink(state, payload) {
            state.step_four_link.link_name = payload.link_name;
            state.step_four_link.link_duration = payload.link_duration;
        },
        SET_DRIVERS(state, drivers) { // Add this mutation
            console.log('Setting drivers:', drivers);
            state.drivers = drivers;
        },
        setAdvertisingGoal(state, goal) {
            if (state.step_one) {
                state.step_one.advertisingGoal = goal;
            } else {
                // Handle case where step_one might not be initialized yet
                console.error("Vuex store: step_one state is not initialized when trying to setAdvertisingGoal.");
                state.step_one = { advertisingGoal: goal }; // Example initialization
            }
        },
    },
    getters: {
        isLoading(state) {
            return state.isLoading;
        },
        isModal(state) {
            return state.isModal;
        },
        step_one(state) {
            return state.step_one;
        },
        step_two(state) {
            return state.step_two;
        },
        step_three(state) {
            return state.step_three;
        },
        step_four(state) {
            return state.step_four;
        },
        ReviewPaymentState(state) {
            return state.isReviewingPayment;
        },
        assignedCarsState(state) {
            return state.assignedCarsState;
        },
        selectedCountriesState(state) {
            return state.selectedCountriesState;
        },
        selectedCitiesState(state) {
            return state.selectedCitiesState;
        },
        selectedDistrictsState(state) {
            return state.selectedDistrictsState;
        },
        drivers(state) { // Add this getter
            return state.drivers;
        }
    },
    actions: {
        async uploadFromVuex(context, payload) {
            const formData = new FormData();
            formData.append("companyName ", context.state.step_one.companyName);
            formData.append("title", context.state.step_one.campaignTitle);
            formData.append("advertising_goal", context.state.step_one.advertisingGoal);
            // append country, city, district here
            console.log(context.state.step_four);
            if (context.state.step_four.length > 0) {
                const media = context.state.step_four[0];
                if (typeof media === 'string') {
                    // Assuming it's a link
                    formData.append("media_link", media);
                } else if (media instanceof File || media instanceof Blob) {
                    // Assuming it's a binary file
                    formData.append("media", media);
                }
            }
            if (context.state.step_four_link.link_name != null) {
                formData.append("link_name", context.state.step_four_link.link_name);
                formData.append("link_duration", context.state.step_four_link.link_duration);
            }
            formData.append(
                "duration[start]",
                context.state.step_three.duration.start.toISOString()
            );
            formData.append("duration[end]", context.state.step_three.duration.end.toISOString());
            // formData.append("markers", "");

            formData.append("budget", context.state.step_three.budget * calculateDaysDifference(context.state.step_three.duration.start, context.state.step_three.duration.end));
            formData.append("terms", true);
            formData.append("", context.state.country_code);
            formData.append("xmin", context.state.expectedMinutes);
            formData.append("xloop", context.state.expectedAdLoops);
            formData.append("ximp", context.state.expectedImpressions);
            formData.append("cars", 6);

            // --- Debug Log: Check state.step_two before sending ---
            // console.log("[DEBUG API Action] Reading context.state.step_two:", JSON.stringify(context.state.step_two, null, 2));
            const locationDataString = JSON.stringify(context.state.step_two);
            // console.log("[DEBUG API Action] Stringified location data being sent:", locationDataString);
            // --- Debug Log End ---

            formData.append("location", locationDataString);

            const apiUrl = "https://publish.dkilo.com/api/CampaignStore";
            const country_code = localStorage.getItem('country_code');
            const response = await axios.post(apiUrl, formData, {
                headers: {
                    token: localStorage.getItem("token"),
                    "Country-Code": country_code,
                    // 'Content-Type': 'multipart/form-data',
                },
            });
            return response.data.campaign_id
            // context.state.step_two[0].center.lat = null;
            // context.state.step_two[0].center.lng = null;
            // for (let i = 0; i < context.state.step_two.length; i++) {
            //     context.state.step_two[i].center.lat = null;
            //     context.state.step_two[i].center.lng = null;
            //     context.state.step_two[i].radius = null;
            // }

            // alert(response.data[0]);
            // location.reload();
            //
            //
        },
        triggerToggleModal({ commit }) {
            commit('restoreStat');
        },
        async getHeatMap(context) {
            const api = "https://publish.dkilo.com/api/heatmap";
            const res = await axios.get(api, {
                headers: { token: localStorage.getItem("token"), "Country-Code": context.state.country_code },
            });
            // context.state.points = [];
            res.data.points.map((p) =>
                context.state.points.push(
                    new google.maps.LatLng(p.coordinates[1], p.coordinates[0])
                )
            );
            context.state.adLoop = res.data.AdLoop;
            context.state.impressions = res.data.impressions;
            context.state.distance = res.data.distance;
        },
        async meFromV(context) {
            let tokeen = localStorage.getItem("token");
            let countryCode = localStorage.getItem("country_code")
            const res = await axios.get("https://publish.dkilo.com/api/me?", {
                headers: { token: tokeen, "Country-Code": countryCode },
            });
            context.state.country_code = res.data.publisher.country_code;
        },
        async fetchDrivers({ commit }) { // Add this action
            try {
                let token = localStorage.getItem("token");
                let country_code = localStorage.getItem("country_code"); // Get country code from localStorage

                if (!country_code) {
                    console.error("Country code not found in localStorage for fetchDrivers action.");
                    // Handle the error appropriately - maybe return or commit an error state
                    return;
                }

                const response = await axios.get('https://publish.dkilo.com/api/screen-track', {
                    headers: { token, "Country-Code": country_code }, // Use the fetched country_code
                });
                commit('SET_DRIVERS', response.data);
            } catch (error) {
                console.error('Error fetching drivers:', error);
                // Optionally commit an error state here as well
            }
        }
    },
});

export default store;
